<template>
    <blank-layout>

        <div class="flex flex-grow flex-row bg-gray-700 justify-center items-center">

            <div class="flex w-full flex-grow justify-center">
                <div class="flex flex-col w-full max-w-xl bg-white rounded-lg shadow-xl text-center p-20 text-gray-700">
                    <div>{{ message }}</div>
                    <div class="mt-5">
                        <a :href="singinUrl"
                            class="bg-birdie-blue hover:bg-birdie-blue/80 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md font-semibold text-white uppercase tracking-widest  focus:outline-none focus:ring focus:ring-gray-300 disabled:opacity-25 disabled:cursor-default transition text-sm">
                            <span>Sign in </span>
                            <ArrowRightIcon class="ml-3 w-4 h-4" />
                        </a>
                    </div>
                </div>


            </div>


        </div>


    </blank-layout>
</template>

<script>

import BlankLayout from "@/Layouts/BlankLayout"
import { ArrowRightIcon } from "@heroicons/vue/24/outline";


export default {
    props: [
        'message',
        'email'
    ],


    components: {
        BlankLayout, ArrowRightIcon

    },
    data() {
        return {


        }
    },
    created() {


    },
    beforeUnmount() {

    },
    mounted() {

    },
    computed: {
        singinUrl() {
            if (this.email) {
                return route('login', { email: this.email })
            }
            return route('login')
        }
    },
    methods: {

    }
}
</script>

<style scoped></style>
